var map = {
	"./symbol_0.png": "c463",
	"./symbol_1.png": "31a8",
	"./symbol_2.png": "195a",
	"./symbol_3.png": "b228",
	"./symbol_4.png": "bb5d",
	"./symbol_5.png": "fc10"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8c2b";